import { ToolRendererProps } from '@/config/types'
import { ProposedFormFieldValue } from '@/events'

export type ProposalPayload = {
  formId?: string
  formName?: string
  fields: ProposedFormFieldValue[]
  notes?: string
}

export const normalizeValue = (value: unknown): string => {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean') return String(value)
  // For objects/arrays, use JSON.stringify to preserve structure
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value)
    } catch {
      return String(value)
    }
  }
  return String(value)
}

export const coerceProposal = (call: ToolRendererProps['call']): ProposalPayload => {
  const raw = (call.output ?? call.input ?? {}) as any
  const fields: ProposedFormFieldValue[] = Array.isArray(raw.fields)
    ? raw.fields
        .map((f: any) => ({
          name: typeof f?.name === 'string' ? f.name : '',
          label: typeof f?.label === 'string' ? f.label : undefined,
          value: normalizeValue(f?.value),
          inputType: typeof f?.inputType === 'string' ? f.inputType : undefined,
          options: Array.isArray(f?.options) ? f.options : undefined
        }))
        .filter((f: ProposedFormFieldValue) => f.name.length > 0)
    : []

  return {
    formId: typeof raw.formId === 'string' ? raw.formId : undefined,
    formName: typeof raw.formName === 'string' ? raw.formName : undefined,
    fields,
    notes: typeof raw.notes === 'string' ? raw.notes : undefined
  }
}
